import { render, staticRenderFns } from "./storeHeader.vue?vue&type=template&id=2c8fd8c8&scoped=true"
import script from "./storeHeader.vue?vue&type=script&lang=js"
export * from "./storeHeader.vue?vue&type=script&lang=js"
import style0 from "./storeHeader.vue?vue&type=style&index=0&id=2c8fd8c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8fd8c8",
  null
  
)

export default component.exports